<template>
  <div class="btn-group dropleft">
    <li class="dropdown">
      <a href="#" id="adjustBgBtn" data-toggle="dropdown">Adjust background</a>
      <ul class="dropdown-menu">
        <ul class="list-inline">
          <li v-for="bg in backgrounds" :key="bg">
            <a @click="backgroundChangeClicked(bg)"
              ><img :src="bg.imageFile"
            /></a>
          </li>
        </ul>
      </ul>
    </li>
  </div>
</template>

<script>
export default {
  name: "BackgroundPartial",
  props: {
    backgrounds: Array,
  },
  methods: {
    backgroundChangeClicked(background) {
      this.$emit("click", background);
    },
  },
  emits: ["click"],
};
</script>

<style scoped>
li {
  list-style: none;
}
li a {
  color: white;
}
li a:hover {
  text-decoration: none;
}
.dropdown {
  margin-top: auto;
  margin-bottom: auto;
}
.dropdown-menu.show {
  position: absolute;
  will-change: transform;
  display: flex;
  flex-wrap: wrap;
  width: 100px;
  height: 350px;
  top: 0px;
  left: 0px;
  transform: translate3d(0px, -370px, 0px) !important;
  overflow: scroll;
  border-radius: 9px;
  margin: 10px 0px auto 0px;
  background: transparent;
  border: none;
}
.list-inline {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: -9px;
}
img {
  width: 158px;
}
a {
  height: 20px;
  width: 162px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: auto;
  margin-bottom: auto;
}

@media only screen and (max-width:600px){
  
  .dropleft {
    width: 100%;
    justify-content: center;
    margin-top: 10px;
    background: var(--yungo-primary-btn-click);
    padding: 10px;
    border-radius: 15px;
     z-index: 999 !important;
  }

  .dropdown-menu.show {
    width: 293px;
    transform: translate3d(-66px, -370px, 0px) !important;
  }

  .dropdown-menu.show ul li a img {
    width: 300px;
  }

  .dropleft.dropdown-menu {
    right: -42% !important;
  }
}
</style>